import type { HudEdge } from '@sorrem/shared';
import classnames from 'classnames';
import type { ReactNode } from 'react';
import styles from './HudDrawer.module.scss';

interface HudDrawerProps {
    /** The screen edge it slides off when closed: the side of its HUD area. */
    readonly edge: HudEdge;
    readonly open: boolean;
    /** The drawer's own extras (sizes, its panel's styles). */
    readonly className?: string;
    readonly children: ReactNode;
}

/**
 * A HUD panel's drawer: closed, it slides off its screen edge, leaving the
 * panel's side label in view to bring it back. The Carried, Map, Commission
 * and gathering Crucible panels all slide this way.
 */
export function HudDrawer({ edge, open, className, children }: HudDrawerProps): JSX.Element {
    return (
        <div className={classnames(styles.hudDrawer, edge === 'left' && styles.left, open && styles.open, className)}>
            {children}
        </div>
    );
}
